export const TOGGLE_BLOCK_TABLE_HISTORY_BUTTON = 'TOGGLE_BLOCK_TABLE_HISTORY_BUTTON'
